import { createFileRoute } from "@tanstack/react-router";
import { ConnectedActivityPage } from "@/components/clients/connected-activity-page";
import { pruneSearch } from "@/lib/router-search";

export const Route = createFileRoute(
	"/$owner/agents/connected/$clientId/activity",
)({
	validateSearch: (search: Record<string, unknown>) =>
		pruneSearch(search) as Record<string, string | undefined>,
	component: ConnectedActivityDetailPage,
});

function ConnectedActivityDetailPage() {
	const { owner, clientId } = Route.useParams();
	const search = Route.useSearch();
	return (
		<ConnectedActivityPage
			owner={owner}
			clientId={clientId}
			mcpActivityId={
				typeof search.mcp_activity_id === "string"
					? search.mcp_activity_id
					: null
			}
		/>
	);
}
